module.exports = __webpack_public_path__ + "img/sprite.d17782ce.png";